import { Variable } from 'alkali'
import { get, post } from 'tools/request'
import app from 'app/app'
import { analysisSelections, currentAnalysisSelections, locked, analysisSaveRequest, updateAnalysis, faqOrReadOnly } from 'model/SearchQuery'

export function getAvailableQuestions(dashboard) {
	return new (Variable.with({ recent: [] , favorites: []}))().to(() => 
		Promise.resolve(app.user).then(user =>
			user ? get('/portal/AnalysisByUserDate?user=' + user.Id + (dashboard ? '&dashboard=true' : '')) : {}))
}
export let availableQuestions = getAvailableQuestions(window.isFAQDashboard)
export const favorites = availableQuestions.property('favorites')
export const favorite = currentAnalysisSelections.to(async analysis => {
	let userId = (await app.user).Id
	return ((!analysis.owner || analysis.owner == userId) && analysis.favorite && !window.isFAQDashboard) || favorites.to(favorites =>
		favorites.find(favorite => favorite.analysis == analysis.id))
})

let favoriting
export async function favoriteQuery() {
	if (favoriting)
		return
	favoriting = true
	try {
		let user = await app.user
		locked.put(false)
		if (!faqOrReadOnly.valueOf() && analysisSelections.get('owner') && user.Id != analysisSelections.get('owner')) {
			analysisSelections.set('owner', 1) // do this to make sure we own the favorite if we can
			await new Promise(setTimeout)
			await updateAnalysis()
			await analysisSaveRequest
		}
		let selections = await analysisSelections
		selections.locked = false
		if (selections.example)
			selections.example = undefined
		if (!selections.owner && user)
			selections.owner = user.Id
		await post('/portal/Favorite', {
			data: {
				analysis: selections.id,
				owner: user.Id,
				name: '',
				app: window.isFAQDashboard ? 'Dashboard' : 'Analytics',
				description: '',
			}
		})
		availableQuestions.updated()
		favorite.updated() // make sure it is updated
		await favorite
	} finally {
		favoriting = false
	}
}
